<template>
  <p
    class="subscription-alert px-3 py-1 m-0"
    :class="roundedClass"
  >
    {{ text }}
  </p>
</template>

<script>
export default {
  name: 'SubscriptionAlert',

  props: {
    text: {
      type: String,
      required: true
    },
    roundedMode: {
      type: String,
      default: 'mdUp',
      validator: v => ['always', 'mdUp'].includes(v)
    }
  },

  computed: {
    roundedClass () {
      return {
        'rounded-always': this.roundedMode === 'always',
        'rounded-md-up': this.roundedMode === 'mdUp'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.subscription-alert {
  font-family: outfit-semi-bold;
  background-color: $color-red-light;
  color: $color-white;
}

.rounded-always {
  border-radius: 6px;
}

.rounded-md-up {
  @include media-breakpoint-up($md) {
    border-radius: 6px;
  }
}
</style>
